
<div class="d-flex">
  <ng-container *ngFor="let item of this.menuItems">
      <ng-container *ngIf="item?.children?.length>0;else elsetmp;" >
          <!-- <button [name]="item.text" mat-button
            class="app-menu-btn vis-menu w-100"
            [matMenuTriggerFor]="priMenu"
            [matMenuTriggerData]="item.id"
            #menuTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            (menuOpened)="onMenuOpen(item.id, $event)"
            (mouseenter)="onMenuHover(menuTrigger, $event)"
            style="flex-grow: 1;">{{item.text}}</button> -->
          <button [name]="item.text" mat-button
            class="app-menu-btn vis-menu w-100"
            [matMenuTriggerFor]="priMenu"
            [matMenuTriggerData]="item.id"
            #menuTrigger="matMenuTrigger"
            (click)="$event.stopPropagation()"
            (menuOpened)="onMenuOpen(item.id, $event)"
            style="flex-grow: 1;">{{item.text}}</button>
          <mat-menu #priMenu="matMenu"
                    [class]="menuPanelClass"
                    [hasBackdrop]="false"
                    xPosition="after"
                    yPosition="below">
              <div>
              <ng-container *ngFor="let child of this.item.children">
                  <ng-container *ngIf="child?.children?.length>0;else elsetmp2;" >
                      <button mat-menu-item class="app-menu-btn"
                        [class.dental-menu-item-selected]="isMenuItemSelected(child)"
                        [matMenuTriggerFor]="secMenu">{{child.text}}</button>
                      <mat-menu #secMenu="matMenu" [class]="menuPanelClass">
                          <ng-container *ngFor="let childchild of this.child.children">
                              <button mat-menu-item class="app-menu-btn"
                                [class.dental-menu-item-selected]="isMenuItemSelected(childchild)"
                                [class.polaris-menu-unavailable]="isPatientCareUnavailable(childchild)"
                                [attr.aria-disabled]="isPatientCareUnavailable(childchild) ? 'true' : null"
                                (click)="redirectTo(childchild)">{{childchild.text}}</button>
                          </ng-container>
                      </mat-menu>
                  </ng-container>
                  <ng-template #elsetmp2>
                      <button mat-menu-item class="app-menu-btn"
                        [class.dental-menu-item-selected]="isMenuItemSelected(child)"
                        [class.polaris-menu-unavailable]="isPatientCareUnavailable(child)"
                        [attr.aria-disabled]="isPatientCareUnavailable(child) ? 'true' : null"
                        (click)="redirectTo(child)">{{child?.text}}</button>
                  </ng-template>
              </ng-container>
          </div>
          </mat-menu>
      </ng-container>
      <ng-template #elsetmp>
          <button mat-button class="app-menu-btn vis-menu home-menu" (click)="redirectTo(item)">{{item?.text}}</button>
      </ng-template>
  </ng-container>
</div>
